import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import ComponentQuery, {
	type RendererContentStateQuery$data,
	type RendererContentStateQuery$variables,
} from './__generated__/RendererContentStateQuery.graphql';

export async function preloadRendererContentState(contentId: string) {
	return query<RendererContentStateQuery$data, RendererContentStateQuery$variables>({
		query: ComponentQuery,
		variables: {
			contentId,
			isDraft: false,
			format: 'USER_FRIENDLY',
		},
		fetchPolicy: 'network-only',
	});
}
